(() => {
  if (!document.body.classList.contains('fcp-v17') && location.pathname !== '/cart') return;
  const modal = document.getElementById('info-modal');
  const content = document.getElementById('info-body');
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-modal]');
    if (trigger && modal) {
      const template = document.querySelector(`template[data-fcp-modal="${trigger.dataset.modal}"]`);
      if (!template) return;
      content.replaceChildren(template.content.cloneNode(true));
      const heading = content.querySelector('h2');
      if (heading) heading.id = 'modal-title';
      modal.showModal();
    }
    const opener = event.target.closest('[data-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.open);
      if (target) { event.preventDefault(); target.open = true; target.scrollIntoView({behavior:'smooth',block:'start'}); }
    }
  });
  modal?.querySelector('.close')?.addEventListener('click', () => modal.close());
  modal?.addEventListener('click', event => { if (event.target === modal) modal.close(); });
  const menu = document.getElementById('menu-toggle');
  menu?.addEventListener('click', () => {
    const open = document.getElementById('nav-links').classList.toggle('open');
    menu.setAttribute('aria-expanded', String(open));
  });
  // Comparison behavior is initialized in the approved design parity layer below.
  document.querySelector('[data-fcp-sticky-buy]')?.addEventListener('click',()=>document.querySelector('.product-form__submit')?.click());
  function stickyPurchase(){
    const button=document.querySelector('.product-form__submit');
    const sticky=document.getElementById('sticky-buy');
    if(!button||!sticky)return;
    const rect=button.getBoundingClientRect();
    sticky.classList.toggle('show',innerWidth<=700 && (rect.bottom<0 || rect.top>innerHeight));
  }
  window.addEventListener('scroll',stickyPurchase,{passive:true});
  window.addEventListener('resize',stickyPurchase);stickyPurchase();
  // Legacy bonus synchronization paused; original source is preserved in release rollback.

})();

/* Move the same native picker, never duplicate option inputs or gallery bindings. */
(() => {
  function placeVariantControls() {
    const product = document.querySelector('.fcp-v17 #product-page product-info');
    if (!product || product.dataset.fcpVariantPositioned) return;
    const gallery = product.querySelector('.gallery');
    const controls = product.querySelector('.fcp-native-variants');
    const purchase = product.querySelector('.buy-row');
    if (!gallery || !controls || !purchase) return;
    product.dataset.fcpVariantPositioned = 'true';
    const desktop = window.matchMedia('(min-width:701px)');
    const position = () => {
      if (!product.isConnected) return;
      const focus = controls.contains(document.activeElement) ? document.activeElement : null;
      const bonus = product.querySelector('.fcp-compact-bonus');
      const anchor = bonus || purchase;
      if (controls.nextElementSibling !== anchor) anchor.before(controls);
      if (focus) focus.focus({preventScroll:true});
    };
    position();
    desktop.addEventListener('change', position);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeVariantControls, {once:true});
  else placeVariantControls();
  document.addEventListener('shopify:section:load', placeVariantControls);
})();
/* Enforce source freshness even on cached pages and variant section replacements. */
(() => {
  const product = document.querySelector('.fcp-v17 #product-page product-info');
  if (!product) return;
  const id = `Inventory-${product.dataset.sectionId}-${product.dataset.productId}`;
  const currentVariant = () => document.forms[product.getAttribute('form')]?.querySelector('input[name="id"]')?.value;
  const sync = () => {
    const holder = document.getElementById(id);
    if (!holder) return;
    const panel = holder.querySelector('[data-fcp-stock-expires]');
    const checked = Number(panel?.dataset.fcpStockChecked);
    const expires = Number(panel?.dataset.fcpStockExpires);
    const now = Date.now();
    const valid = !!panel && Number.isFinite(checked) && Number.isFinite(expires) && checked <= now && expires > now && expires - checked === 600000;
    holder.hidden = !valid;
    if (panel) panel.hidden = !valid;
  };
  let fetching = false;
  const refresh = async () => {
    sync();
    if (document.hidden || fetching || !product.isConnected) return;
    const variant = currentVariant();
    if (!variant) return;
    fetching = true;
    try {
      const url = new URL(product.dataset.productUrl, location.origin);
      url.searchParams.set('variant', variant);
      url.searchParams.set('section_id', product.dataset.sectionId);
      const response = await fetch(url, {cache:'no-store'});
      if (!response.ok) return;
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (currentVariant() !== variant) return;
      const source = parsed.getElementById(id);
      const destination = document.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
    } catch (_) { /* Existing data expires closed; no substitute quantity. */ }
    finally { fetching = false; sync(); }
  };
  sync();
  new MutationObserver(sync).observe(product, {childList:true,subtree:true});
  setInterval(sync, 1000);
  setInterval(refresh, 120000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', sync);
})();

/* Approved design parity; native cart, gift, review and quiz integrations retained. */
(() => {
 const init=()=>{
  const product=document.querySelector('#product-page product-info');
  if(product){
   const section=product.closest('.shopify-section');
   const video=[...document.querySelectorAll('main>.shopify-section')].find(e=>e!==section&&e.querySelector('.vs-stories-section'));
   if(video){video.classList.add('preview-purchase-carousel');product.after(video);}
  }
  // Clear only the retired gift choice; no cart or customer data is stored here.
  try{sessionStorage.removeItem('fcp-v17-gift-preference');}catch{}
  // Remove decorative arrow glyphs only within CTA controls.
  document.querySelectorAll('.fcp-v17 .btn,.fcp-v17 .product-form__submit').forEach(button=>{const walk=document.createTreeWalker(button,NodeFilter.SHOW_TEXT);while(walk.nextNode())walk.currentNode.textContent=walk.currentNode.textContent.replace(/[↗↘→←]/g,'');});
  const table=document.querySelector('.brand-comparison'),select=document.getElementById('preview-brand'),toggle=document.getElementById('comparison-toggle'),reveal=document.getElementById('comparison-rows');
  if(table&&select&&toggle&&reveal){
   const choose=()=>table.querySelectorAll('[data-comparison-column]').forEach(cell=>{const i=Number(cell.dataset.comparisonColumn);cell.hidden=i>1&&i!==Number(select.value);});
   const expand=open=>{reveal.classList.toggle('expanded',open);[...table.tBodies[0].rows].forEach((row,i)=>row.hidden=!open&&i>3);toggle.setAttribute('aria-expanded',String(open));toggle.textContent=open?'Show less':'See full comparison';};
   select.addEventListener('change',choose);toggle.addEventListener('click',()=>expand(toggle.getAttribute('aria-expanded')!=='true'));choose();expand(false);
   table.querySelectorAll('td').forEach(cell=>{const text=cell.textContent.trim();if(/^[✓✔]$/.test(text)){cell.setAttribute('aria-label','Included');cell.setAttribute('role','img');}else if(/^[×✕✗✘Xx]$/.test(text)){cell.setAttribute('aria-label','Not included');cell.setAttribute('role','img');}});
  }
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

/* Stabilization: keep signup and native dialogs from stacking; recover only an orphaned signup-owned lock. */
(() => {
 if (!document.body.classList.contains('fcp-v17') && !/\/cart\/?$/.test(location.pathname)) return;
 const nativeDialog = () => document.querySelector('#info-modal[open]');
 const visible = element => {
  if (!element) return false;
  const style = getComputedStyle(element), box = element.getBoundingClientRect();
  return style.display !== 'none' && style.visibility !== 'hidden' && box.width > 0 && box.height > 0 && box.bottom > 0 && box.right > 0 && box.top < innerHeight && box.left < innerWidth;
 };
 const signupDialogs = () => [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].filter(element => element.className.includes('kl-private') && visible(element));
 const actualModalOpen = () => [...document.querySelectorAll('dialog[open],[aria-modal="true"]')].some(visible);
 let signupBehindNative = false;
 const closingSignups = new WeakSet();
 const recoverSignupLock = () => {
  if (!document.body.classList.contains('klaviyo-prevent-body-scrolling')) return;
  if (signupDialogs().length || actualModalOpen()) return;
  // No overflow/style override: other native dialog and drawer owners retain their own locks.
  document.body.classList.remove('klaviyo-prevent-body-scrolling');
 };
 const afterClose = () => { setTimeout(recoverSignupLock, 250); setTimeout(recoverSignupLock, 1000); };
 const closeOverlappingSignup = () => {
  const modal = nativeDialog();
  if (!modal && !signupBehindNative) return;
  const dialogs = signupDialogs();
  if (!dialogs.length) { afterClose(); return; }
  const focused = document.activeElement;
  let closed = false;
  for (const dialog of dialogs) {
   if (closingSignups.has(dialog)) continue;
   const close = dialog.querySelector('button.klaviyo-close-form[aria-label="Close dialog"]');
   if (close && visible(close)) {
    closingSignups.add(dialog);
    close.click(); closed = true;
    // Let the signup SDK finish closing before another lifecycle notification retries.
    setTimeout(() => { closingSignups.delete(dialog); if (nativeDialog()) inspectOverlap(); },1000);
   }
  }
  if (closed) {
   signupBehindNative = false;
   if (modal?.open) requestAnimationFrame(() => {
    if (!modal.open) return;
    const target = modal.contains(focused) && focused?.isConnected ? focused : modal.querySelector('button');
    target?.focus({preventScroll:true});
   });
   afterClose();
  }
 };
 const inspectOverlap = () => {
  if (nativeDialog() && signupDialogs().length) signupBehindNative = true;
  closeOverlappingSignup();
 };
 window.addEventListener('klaviyoForms', event => {
  const type = event.detail?.type;
  if (type === 'open') {
   if (nativeDialog()) signupBehindNative = true;
   for (const delay of [50,250,650]) setTimeout(inspectOverlap,delay);
  } else if (type === 'close') afterClose();
 });
 const modal = document.getElementById('info-modal');
 if (modal) {
  // Signup can finish rendering after its open event or its first close attempt.
  // Observe that lifecycle only while the native dialog is actually open.
  let frame = 0;
  const signupChanges = new MutationObserver(() => {
   if (frame || !modal.open) return;
   frame = requestAnimationFrame(() => { frame = 0; inspectOverlap(); });
  });
  new MutationObserver(() => {
   if (modal.open) {
    signupChanges.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','aria-modal']});
    for (const delay of [0,150,500]) setTimeout(inspectOverlap,delay);
   } else { signupChanges.disconnect(); afterClose(); }
  }).observe(modal,{attributes:true,attributeFilter:['open']});
  modal.addEventListener('close',afterClose);
 }
 new MutationObserver(() => {
  if (document.body.classList.contains('klaviyo-prevent-body-scrolling')) afterClose();
 }).observe(document.body,{attributes:true,attributeFilter:['class']});
 window.addEventListener('pageshow',afterClose);
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)afterClose();});
})();

/* Product photos: real navigation controls and mouse dragging; native touch stays unchanged. */
(() => {
 const root=document.querySelector('.fcp-v17 #product-page');if(!root)return;
 const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 const scroll=(el,left)=>el.scrollTo({left,behavior:reduced()?'instant':'smooth'});
 function mount(){
  const gallery=root.querySelector('.gallery'),main=gallery?.querySelector('media-gallery slider-element'),rail=gallery?.querySelector('media-dots');
  if(!gallery||!main||!rail||gallery.dataset.fcpPhotoNavigation)return;
  gallery.dataset.fcpPhotoNavigation='true';
  if(getComputedStyle(gallery).position==='static')gallery.classList.add('fcp-gallery-relative');
  main.classList.add('fcp-mouse-photo-scroll');rail.classList.add('fcp-mouse-photo-scroll');
  const items=()=>main.itemsToShow||[...main.children].filter(e=>e.clientWidth>0);
  const offsets=()=>{const list=items(),first=list[0]?.offsetLeft||0;return list.map(e=>e.offsetLeft-first);};
  const nearest=()=>{const positions=offsets();return positions.reduce((best,x,i)=>Math.abs(x-main.scrollLeft)<Math.abs(positions[best]-main.scrollLeft)?i:best,0);};
  if(!main.id)main.id='fcp-product-photo-slider';if(!rail.id)rail.id='fcp-product-photo-thumbnails';
  const button=(label,direction)=>{const b=document.createElement('button');b.type='button';b.className='fcp-gallery-button';b.setAttribute('aria-label',label);b.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="'+(direction<0?'m15 5-7 7 7 7':'m9 5 7 7-7 7')+'"/></svg>';return b;};
  const nav=document.createElement('div');nav.className='fcp-gallery-photo-controls';nav.setAttribute('role','group');nav.setAttribute('aria-label','Product photo navigation');
  const previous=button('Previous product photo',-1),next=button('Next product photo',1),status=document.createElement('span');status.className='fcp-gallery-status';status.setAttribute('role','status');status.setAttribute('aria-atomic','true');
  for(const b of [previous,next])b.setAttribute('aria-controls',main.id);nav.append(previous,status,next);gallery.append(nav);
  const railNav=document.createElement('div');railNav.className='fcp-gallery-thumbnail-controls';railNav.setAttribute('role','group');railNav.setAttribute('aria-label','Thumbnail navigation');
  const railPrevious=button('Previous thumbnails',-1),railNext=button('Next thumbnails',1);for(const b of [railPrevious,railNext])b.setAttribute('aria-controls',rail.id);railNav.append(railPrevious,railNext);gallery.append(railNav);
  const shadowHost=rail.closest('scroll-shadow'),shadow=shadowHost?.shadowRoot||shadowHost?.querySelector('template')?.content;if(shadow&&!shadow.querySelector('[data-fcp-photo-indicators]')){const style=document.createElement('style');style.dataset.fcpPhotoIndicators='true';style.textContent='span.l,span.r{display:none!important}';shadow.append(style);}
  let requested=null,settleTimer,touchGesture=null,pendingTouch=null,touchTimer;
  function update(){const count=items().length,index=nearest(),controlIndex=requested??index;previous.disabled=count<2||controlIndex<=0;next.disabled=count<2||controlIndex>=count-1;nav.hidden=count<2;railPrevious.disabled=rail.scrollLeft<=1;railNext.disabled=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-1;railNav.hidden=rail.scrollWidth<=rail.clientWidth+1;status.textContent='Photo '+(index+1)+' of '+count;const r=main.getBoundingClientRect(),g=gallery.getBoundingClientRect();nav.style.left=(r.left-g.left+12)+'px';nav.style.top=(matchMedia('(min-width:701px) and (hover:hover) and (pointer:fine)').matches?r.top-g.top+r.height/2:r.bottom-g.top-30)+'px';nav.style.width=Math.max(0,r.width-24)+'px';}
  function navigate(step,event){event.preventDefault();event.stopPropagation();requested=Math.max(0,Math.min(items().length-1,(requested??nearest())+step));scroll(main,offsets()[requested]||0);update();}
  previous.addEventListener('click',e=>navigate(-1,e));next.addEventListener('click',e=>navigate(1,e));
  for(const [b,step]of [[railPrevious,-1],[railNext,1]])b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();scroll(rail,rail.scrollLeft+step*rail.clientWidth*.75);});
  main.addEventListener('scroll',()=>{clearTimeout(settleTimer);settleTimer=setTimeout(()=>{requested=null;update();},180);},{passive:true});main.addEventListener('scrollend',()=>{requested=null;update();});rail.addEventListener('scroll',update,{passive:true});
  function settleShortSwipe(){const gesture=pendingTouch;if(!gesture)return;clearTimeout(touchTimer);if(nearest()!==gesture.index){pendingTouch=null;return;}const positions=offsets();if(Math.abs(main.scrollLeft-(positions[gesture.index]||0))<6){pendingTouch=null;requested=Math.max(0,Math.min(positions.length-1,gesture.index+gesture.step));scroll(main,positions[requested]||0);update();}else if(performance.now()-gesture.ended<800)touchTimer=setTimeout(settleShortSwipe,80);else pendingTouch=null;}
  main.addEventListener('touchstart',event=>{clearTimeout(touchTimer);pendingTouch=null;const t=event.touches[0];touchGesture=event.touches.length===1?{id:t.identifier,x:t.clientX,y:t.clientY,index:nearest(),at:performance.now()}:null;},{passive:true});
  main.addEventListener('touchmove',event=>{if(event.touches.length!==1)touchGesture=null;},{passive:true});
  main.addEventListener('touchcancel',()=>{touchGesture=null;pendingTouch=null;clearTimeout(touchTimer);},{passive:true});
  main.addEventListener('touchend',event=>{const gesture=touchGesture;touchGesture=null;if(!gesture||event.touches.length)return;const t=[...event.changedTouches].find(t=>t.identifier===gesture.id);if(!t)return;const dx=t.clientX-gesture.x,dy=t.clientY-gesture.y;if(performance.now()-gesture.at>700||Math.abs(dx)<Math.min(60,main.clientWidth*.15)||Math.abs(dx)<Math.abs(dy)*1.5)return;pendingTouch={index:gesture.index,step:dx<0?1:-1,ended:performance.now()};touchTimer=setTimeout(settleShortSwipe,250);},{passive:true});
  main.addEventListener('scrollend',settleShortSwipe);
  new ResizeObserver(update).observe(main);new ResizeObserver(update).observe(rail);new MutationObserver(update).observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','style']});
  function enableMouseDrag(el,isMain){let drag=null,suppressClick=false;
   const finish=(event,cancel=false)=>{if(!drag||(event?.pointerId!==undefined&&event.pointerId!==drag.id))return;const ended=drag;drag=null;if(ended.moved){let target=null;if(isMain){const positions=offsets();let index=nearest();if(!cancel&&index===ended.index&&Math.abs(ended.dx)>=Math.min(80,el.clientWidth*.15))index=Math.max(0,Math.min(positions.length-1,index+(ended.dx<0?1:-1)));target=positions[index]||0;}el.style.scrollSnapType=ended.snap;el.style.scrollBehavior=ended.behavior;el.style.userSelect=ended.select;el.classList.remove('fcp-photo-dragging');if(target!==null)scroll(el,target);suppressClick=true;setTimeout(()=>{suppressClick=false;},250);}try{if(el.hasPointerCapture(ended.id))el.releasePointerCapture(ended.id);}catch{}requested=null;update();};
   el.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('video,iframe,model-viewer,a,input,select,textarea')||isMain&&event.target.closest('button'))return;drag={id:event.pointerId,x:event.clientX,y:event.clientY,left:el.scrollLeft,index:nearest(),dx:0,moved:false,snap:el.style.scrollSnapType,behavior:el.style.scrollBehavior,select:el.style.userSelect};});
   el.addEventListener('pointermove',event=>{if(!drag||event.pointerId!==drag.id)return;const dx=event.clientX-drag.x,dy=event.clientY-drag.y;if(!drag.moved){if(Math.abs(dx)<8||Math.abs(dx)<=Math.abs(dy))return;drag.moved=true;el.style.scrollSnapType='none';el.style.scrollBehavior='auto';el.style.userSelect='none';el.classList.add('fcp-photo-dragging');el.setPointerCapture(event.pointerId);}drag.dx=dx;event.preventDefault();el.scrollLeft=drag.left-dx;});
   el.addEventListener('dragstart',event=>{if(event.target.closest('img'))event.preventDefault();});
   el.addEventListener('click',event=>{if(suppressClick){suppressClick=false;event.preventDefault();event.stopImmediatePropagation();}},true);
   window.addEventListener('pointerup',event=>finish(event));window.addEventListener('pointercancel',event=>finish(event,true));el.addEventListener('lostpointercapture',event=>finish(event,true));window.addEventListener('blur',()=>finish(null,true));document.addEventListener('visibilitychange',()=>{if(document.hidden)finish(null,true);});
  }
  enableMouseDrag(main,true);enableMouseDrag(rail,false);update();
 }
 customElements.whenDefined('slider-element').then(mount);new MutationObserver(mount).observe(root,{childList:true,subtree:true});
})();
